@if (visible) {
  <div class="progress-container">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
}
